import { useEffect, useRef } from 'react';

interface Props {
  data: object;
}

export default function JsonLd({ data }: Props) {
  const idRef = useRef('jsonld-' + Math.random().toString(36).substr(2, 9));

  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = idRef.current;
    script.text = JSON.stringify(data);
    document.head.appendChild(script);
    return () => {
      const el = document.getElementById(idRef.current);
      if (el) document.head.removeChild(el);
    };
  }, [JSON.stringify(data)]);

  return null;
}
